import React, { FC, memo } from "react";
import { Flex, Icon, LinearProgress } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { formatNumber } from "utils/formatNumber";
import { LinearProgressContainer, ProgressBlockContainer, ProgressTitle } from "../styled";
import { ImportProgressBlockProps } from "../types";

const ImportProgressBlockComponent: FC<ImportProgressBlockProps> = ({
  estimatedRecords = 0,
  processedRecords = 0,
  importInProgress,
  layerCreating,
  layerCreated,
}) => {
  const { t } = useTranslation("dialogs");
  const done = processedRecords / (estimatedRecords / 100);
  const formattedEstimated = formatNumber(estimatedRecords);
  const formattedProcessed = formatNumber(processedRecords);

  return (
    <ProgressBlockContainer column>
      <LinearProgressContainer>
        {(importInProgress || layerCreating) && (
          <>
            <ProgressTitle>
              {layerCreating
                ? t("import.layerCreation")
                : `${t("import.objectsImport")} ${formattedProcessed} / ${formattedEstimated}`}
            </ProgressTitle>
            <LinearProgress done={processedRecords === 0 ? undefined : done} />
          </>
        )}
        {layerCreated && (
          <>
            <Flex style={{ alignItems: "baseline" }}>
              <ProgressTitle>{t("import.layerCreated")}</ProgressTitle>
              <Icon style={{ marginLeft: "0.5rem" }} primary kind="success" />
            </Flex>
            <LinearProgress done={100} />
          </>
        )}
      </LinearProgressContainer>
    </ProgressBlockContainer>
  );
};

export const ImportProgressBlock = memo(ImportProgressBlockComponent);
